import { APIClient, getLoggedinUser, setAuthorization } from './apiCore';
import * as url from './urls';

const api = new APIClient();

const getFavourites = () => {
    return api.get(url.GET_FAVOURITES);
};

const getDirectMessages = (
    instance: string,
    search: string,
    page: number,
    chunkSize: number
) => {
    const userProfileSession = getLoggedinUser();
    setAuthorization(userProfileSession.data.acces_token);
    return api.get(url.GET_DIRECT_MESSAGES, {
        params: {
            'where[instanceA]': instance,
            'where[person][OR][0][firstName][contains]': search,
            'where[person][OR][1][lastName][contains]': search,
            'where[person][OR][2][displayName][contains]': search,
            'where[person][OR][3][phoneNumber][contains]': search,
            take: chunkSize,
            page,
            'orderBy[updatedAt]': 'desc'
        }
    });
};
const getChannels = () => {
    return api.get(url.GET_CHANNELS);
};

const addContacts = (contacts: Array<string | number>) => {
    return api.create(url.ADD_CONTACTS, contacts);
};

const createChannel = (data: object) => {
    return api.create(url.CREATE_CHANNEL, data);
};

const getChatUserDetails = (personId: string | number) => {
    const userProfileSession = getLoggedinUser();
    setAuthorization(userProfileSession.data.acces_token);
    return api.get(url.GET_CHAT_USER_DETAILS, {
        params: { 'where[personId]': personId }
    });
};

const getChatUserConversations = (
    conversarionId: string,
    page: number,
    chunkSize: number
) => {
    const userProfileSession = getLoggedinUser();
    setAuthorization(userProfileSession.data.acces_token);
    return api.get(url.GET_CHAT_USER_MESSAGES + '/' + conversarionId, {
        params: { take: chunkSize, page, 'orderBy[updatedAt]': 'desc' }
    });
};

const getChatUserConversationsByInstance = (
    personId: number,
    instance: string
) => {
    const userProfileSession = getLoggedinUser();
    setAuthorization(userProfileSession.data.acces_token);
    return api.get(url.GET_CHAT_USER_MESSAGES, {
        params: {
            'where[AND][0][instanceA]': instance,
            'where[AND][1][personId]': personId,
            take: 1,
            page: 1,
            'orderBy[updatedAt]': 'desc'
        }
    });
};

const sendMessage = (data: object) => {
    return api.create(url.SEND_MESSAGE, data);
};

const receiveMessage = (id: string | number) => {
    return api.update(url.RECEIVE_MESSAGE + '/' + id, { params: { id } });
};

const readMessage = (id: string | number) => {
    return api.update(url.READ_MESSAGE + '/' + id, { params: { id } });
};

const receiveMessageFromUser = (id: string | number) => {
    return api.get(url.RECEIVE_MESSAGE_FROM_USER + '/' + id, {
        params: { id }
    });
};

const deleteMessage = (userId: number | string, messageId: number | string) => {
    return api.delete(url.DELETE_MESSAGE + '/' + userId + '/' + messageId, {
        params: { userId, messageId }
    });
};

const forwardMessage = (data: object) => {
    return api.create(url.FORWARD_MESSAGE, data);
};

const deleteUserMessages = (userId: number | string) => {
    return api.delete(url.DELETE_USER_MESSAGES + '/' + userId, {
        params: { userId }
    });
};

const getChannelDetails = (id: string | number) => {
    return api.get(url.GET_CHANNEL_DETAILS + '/' + id, { params: { id } });
};

const toggleFavouriteContact = (id: string | number) => {
    return api.update(url.TOGGLE_FAVOURITE_CONTACT + '/' + id, {
        params: { id }
    });
};

/*
archive
*/
const getArchiveContact = () => {
    return api.get(url.GET_ARCHIVE_CONTACT);
};

const toggleArchiveContact = (id: string | number) => {
    return api.update(url.TOGGLE_ARCHIVE_CONTACT + '/' + id, {
        params: { id }
    });
};

const readConversation = (conversationId: string) => {
    return api.updateAttribute(
        `${url.READ_CONVERSATION}/${conversationId}/readMessages`
    );
};

const deleteImage = (
    userId: number | string,
    messageId: number | string,
    imageId: number | string
) => {
    return api.delete(url.DELETE_IMAGE + '/' + userId + '/' + messageId, {
        params: { userId, messageId, imageId }
    });
};

export {
    getFavourites,
    getDirectMessages,
    getChannels,
    addContacts,
    createChannel,
    getChatUserDetails,
    getChatUserConversations,
    getChatUserConversationsByInstance,
    sendMessage,
    receiveMessage,
    readMessage,
    receiveMessageFromUser,
    deleteMessage,
    forwardMessage,
    deleteUserMessages,
    getChannelDetails,
    toggleFavouriteContact,
    getArchiveContact,
    toggleArchiveContact,
    readConversation,
    deleteImage
};
